import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, BehaviorSubject, tap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ListarNotificacoesResponse } from '../models/notificacao.model';

@Injectable({
  providedIn: 'root',
})
export class NotificacaoService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/notificacoes`;

  private readonly totalNaoLidasSubject = new BehaviorSubject<number>(0);
  public totalNaoLidas$ = this.totalNaoLidasSubject.asObservable();

  listar(pagina = 1): Observable<ListarNotificacoesResponse> {
    const params = new HttpParams().set('page', pagina);
    return this.http
      .get<ListarNotificacoesResponse>(this.apiUrl, { params })
      .pipe(
        tap(response => {
          this.totalNaoLidasSubject.next(response.totalNaoLidas);
        }),
      );
  }

  marcarComoLida(notificacaoId: string): Observable<{ message: string }> {
    return this.http
      .patch<{ message: string }>(`${this.apiUrl}/${notificacaoId}/lida`, {})
      .pipe(
        tap(() => {
          const current = this.totalNaoLidasSubject.value;
          this.totalNaoLidasSubject.next(Math.max(0, current - 1));
        }),
      );
  }

  marcarTodasComoLidas(): Observable<{
    message: string;
    totalMarcadas: number;
  }> {
    return this.http
      .patch<{
        message: string;
        totalMarcadas: number;
      }>(`${this.apiUrl}/marcar-todas-lidas`, {})
      .pipe(
        tap(() => {
          this.totalNaoLidasSubject.next(0);
        }),
      );
  }

  atualizarTotalNaoLidas(): void {
    this.listar().subscribe();
  }

  getTotalNaoLidas(): number {
    return this.totalNaoLidasSubject.value;
  }
}
